/* ============================================================
   MARCIN / ADVERTORIAL - portfolio
   ============================================================ */

// -------- Data ---------------------------------------------------------------
const PAGES = [
  {
    slug: "caraway-bakeware",
    brand: "Caraway",
    title: "Bakeware listicle, housewares vertical.",
    desc:  "Proved the listicle formula transfers out of supplements into home goods.",
    metric: { value: "V2", unit: "" },
    metricLabel: "Iteration",
    tag: "Cross-vertical",
    notes: [
      { at: 0.00, label: "Editorial frame", text: "Leading with a trusted third-party voice (Women's Health) to borrow credibility before selling anything." },
      { at: 0.18, label: "The lead",        text: "Hook built around a relatable kitchen pain point, not the product. Pulls the reader into the story first." },
      { at: 0.42, label: "Mechanism",       text: "Explaining why ceramic non-stick is the breakthrough. Education bridges straight into the product reveal." },
      { at: 0.68, label: "Proof stack",     text: "Ratings, press logos, UGC imagery. Belief threshold for a premium housewares purchase." },
      { at: 0.88, label: "Soft CTA",        text: "Editorial-style close, ends on 'see for yourself' energy rather than a hard sell." },
    ],
  },
  {
    slug: "forbes",
    brand: "Forbes Health",
    title: "GLP-1 listicle for Forbes Health.",
    desc:  "Ran as a paid editorial unit. Listicle format scaled cold traffic across multiple offers.",
    metric: { value: "1", unit: " of 1" },
    metricLabel: "Forbes placement",
    tag: "Published work",
    tagFeatured: true,
    notes: [
      { at: 0.00, label: "Lead",          text: "Opens with what we lead with for this customer avatar. Frames the GLP-1 category in Forbes' editorial voice." },
      { at: 0.18, label: "Education",     text: "Explains why traditional dieting fails. Plants the problem before the reader meets any brand." },
      { at: 0.40, label: "Category primer", text: "Teaches the mechanism. Reader gets smart before seeing options, which increases trust in the ranking." },
      { at: 0.62, label: "The ranking",   text: "Listicle format. Each provider stack-ranked on the reader's real criteria." },
      { at: 0.85, label: "Branded CTA",   text: "Each card ends on a Forbes-approved click-out. Editorial → commerce handoff." },
    ],
  },
  {
    slug: "arq8",
    brand: "Arq8",
    title: "GLP-1 muscle-preservation editorial.",
    desc:  "Doctor-reviewed advertorial for GLP-1 users afraid of losing strength and energy.",
    metric: { value: "MD", unit: "" },
    metricLabel: "Doctor-reviewed",
    tag: "Flagship build",
    notes: [
      { at: 0.00, label: "Hero hook",       text: "Angle-led headline: keep your strength, energy and edge ON a GLP-1. Speaks to the fear, not the drug." },
      { at: 0.22, label: "Doctor authority", text: "Reviewed by an MD up top. Borrows clinical credibility before any claim lands." },
      { at: 0.48, label: "The mechanism",   text: "Why GLP-1 weight loss costs muscle, and what to add so it doesn't. Educates before it sells." },
      { at: 0.74, label: "Proof + reviews", text: "Real-user results and ratings tuned to the GLP-1-curious reader." },
      { at: 0.92, label: "Soft CTA",        text: "Closes on a low-pressure try. Spec and reassurance over hype." },
    ],
  },
  {
    slug: "audien",
    brand: "Surreal",
    title: "Type 2 caregiver editorial, low-sugar breakfast.",
    desc:  "Spouse-POV story selling a sub-1g-sugar cereal to the diabetes-conscious household.",
    metric: { value: "4.7", unit: "★" },
    metricLabel: "10,000+ reviews",
    tag: "Editorial",
    notes: [
      { at: 0.00, label: "Caregiver hook",    text: "First-person spouse story: what breakfast became after a Type 2 diagnosis. Emotional, not clinical." },
      { at: 0.25, label: "Relatable problem", text: "He quietly stopped eating it. Names the small daily moment the reader recognizes." },
      { at: 0.55, label: "Proof density",     text: "4.7/5 from 10,000+ reviews, under 1g of sugar. Trust signals stacked for a health-anxious buyer." },
      { at: 0.85, label: "Permission close",  text: "Money-back guarantee. Ends on a low-risk reason to put it back on the table." },
    ],
  },
  {
    slug: "caraway-cutting-boards",
    brand: "Caraway",
    title: "Cutting boards listicle, second Caraway variant.",
    desc:  "Extended the Caraway formula into a new SKU line. Same skeleton, fresh angle.",
    metric: { value: "V1", unit: "" },
    metricLabel: "New SKU variant",
    tag: "Variant",
    notes: [
      { at: 0.00, label: "Same skeleton",  text: "Caraway bakeware template, re-angled for cutting boards. Proves the architecture ports across SKUs." },
      { at: 0.25, label: "New angle",      text: "Material story (hardwood vs plastic) becomes the new hook, category education built for this product." },
      { at: 0.58, label: "Gift positioning", text: "Reframed for gifting. Small tweak, big conversion impact for housewares." },
      { at: 0.88, label: "CTA",            text: "Editorial button style preserved. Visually consistent with the rest of the Caraway funnel." },
    ],
  },
  {
    slug: "nirapet",
    brand: "Nira Pet",
    title: "6-reasons listicle, pet health.",
    desc:  "Built on a separate store. Template portability across Shopify environments.",
    metric: { value: "6", unit: " reasons" },
    metricLabel: "Listicle format",
    tag: "Multi-store",
    notes: [
      { at: 0.00, label: "Cross-store",    text: "Built on a separate Shopify store (nira-pet-ip). Proves template portability across environments." },
      { at: 0.22, label: "Pet-owner hook", text: "Emotional lead, your dog's comfort. Pet vertical buys on love, not spec sheets." },
      { at: 0.55, label: "6 reasons",      text: "Numbered listicle tuned to pet-parent objections. Each point answers a 'but what about...' worry." },
      { at: 0.88, label: "Vet-style close", text: "Authority layer + softer CTA. Pet buyers convert on reassurance, not urgency." },
    ],
  },
  {
    slug: "arq8longnew",
    brand: "James & Ella",
    title: "Fussy-eater editorial, freeze-dried dog food.",
    desc:  "First-person story: a dog that stopped eating, and the food switch that fixed it in 14 days.",
    metric: { value: "4.9", unit: "★" },
    metricLabel: "900+ reviews",
    tag: "Editorial",
    notes: [
      { at: 0.00, label: "Story hook",     text: "First-person: 'Why my Cocker stopped eating.' A specific, worrying pet-owner moment, not a product pitch." },
      { at: 0.25, label: "Vet dead-end",   text: "Bloods normal, kibble 'fine' — names the frustration of being told nothing's wrong. Builds tension." },
      { at: 0.55, label: "The switch",     text: "The food change that fixed it in 14 days. Mechanism arrives as story payoff, not a spec sheet." },
      { at: 0.80, label: "Proof + reviews", text: "4.9/5 from 900+ Trustpilot reviews. Trust density tuned for an anxious, skeptical pet parent." },
      { at: 0.92, label: "Trial CTA",      text: "20% off subscription, 14-day trial bag, cancel anytime. Low-risk entry to a subscription." },
    ],
  },
  {
    slug: "longevity",
    brand: "Audien",
    title: "Hearing aids reframed around brain health.",
    desc:  "HDR editorial using a Johns Hopkins angle to move an older, cautious buyer.",
    metric: { value: "OTC", unit: "" },
    metricLabel: "FDA-registered",
    tag: "Editorial",
    notes: [
      { at: 0.00, label: "Story hook",         text: "'I waited 10 years.' A Johns Hopkins study becomes the trigger to act. Authority-led lead." },
      { at: 0.25, label: "Brain-health angle", text: "Reframes hearing aids around cognitive decline, not vanity. Raises the stakes for an older reader." },
      { at: 0.55, label: "Trust + proof",      text: "FDA-registered OTC, 1.5M+ customers, Fortune and NYP. Heavy proof for a cautious demo." },
      { at: 0.85, label: "Risk reversal",      text: "45-day risk-free trial up front. Carries the conversion on a considered purchase." },
    ],
  },
];

// -------- Ticker data -------------------------------------------------------
const TICKER_ITEMS = [
  { k: "PAGES SHIPPED",       v: "40+" },
  { k: "BRANDS",              v: "7" },
  { k: "FEATURED IN",         v: "FORBES" },
  { k: "AVG BUILD TIME",      v: "3 DAYS" },
  { k: "LISTICLE FORMAT",     v: "BATTLE-TESTED" },
  { k: "MASTER TEMPLATES",    v: "3" },
  { k: "STORES",              v: "MULTI" },
  { k: "CATEGORIES",          v: "HEALTH / HOUSEWARES / PET / WELLNESS" },
  { k: "RISK REVERSAL",       v: "BEAT YOUR CONTROL OR IT'S FREE" },
  { k: "STATUS",              v: "2 SLOTS OPEN Q2" },
];

// -------- Render: Ticker ----------------------------------------------------
(function renderTicker() {
  const track = document.getElementById("tickerTrack");
  if (!track) return;

  const build = () => TICKER_ITEMS.map(i =>
    `<span class="ticker__item"><span>${i.k}</span><strong>${i.v}</strong><span class="sep">//</span></span>`
  ).join("");

  track.innerHTML = build() + build();
})();

// -------- Wall: swipe dots on mobile ---------------------------------------
function setupWallDots() {
  const rail = document.getElementById("wallGrid");
  const dotsEl = document.getElementById("wallDots");
  if (!rail || !dotsEl) return;
  const phones = Array.from(rail.querySelectorAll(".phone"));
  if (!phones.length) return;

  dotsEl.innerHTML = phones.map((_, i) =>
    `<button class="dot" type="button" data-i="${i}" aria-label="Scroll to page ${i + 1}"></button>`
  ).join("");
  const dots = Array.from(dotsEl.querySelectorAll(".dot"));

  const step = () => {
    if (phones.length < 2) return rail.clientWidth;
    return phones[1].getBoundingClientRect().left - phones[0].getBoundingClientRect().left;
  };
  const update = () => {
    const s = step();
    const i = s ? Math.max(0, Math.min(phones.length - 1, Math.round(rail.scrollLeft / s))) : 0;
    dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
  };

  dots.forEach(d => d.addEventListener("click", () => {
    rail.scrollTo({ left: parseInt(d.dataset.i, 10) * step(), behavior: "smooth" });
  }));
  rail.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
}

// -------- Render: Device wall ----------------------------------------------
(function renderDeviceWall() {
  const wall = document.getElementById("wallGrid");
  if (!wall) return;
  const _ref = window.GA_ASSET_REF || "";
  const cdnBase = _ref ? _ref.split("ga-screenshot-arq8-thumb.webp")[0] : "";
  const cb = window.GA_CACHEBUST ? `?v=${window.GA_CACHEBUST}` : "";
  const thumbUrl = (slug) => cdnBase ? `${cdnBase}ga-screenshot-${slug}-thumb.webp${cb}` : `../assets/screenshots/${slug}-thumb.webp`;
  const fullUrl  = (slug) => cdnBase ? `${cdnBase}ga-screenshot-${slug}.png${cb}` : `../assets/screenshots/${slug}.png`;
  setTimeout(setupWallDots, 0);

  wall.innerHTML = PAGES.map((p) => `
    <button class="phone" type="button" data-slug="${p.slug}" data-brand="${p.brand}" aria-label="Open the ${p.brand} page: ${p.title}">
      <div class="phone__screen">
        <img class="phone__img"
             src="${thumbUrl(p.slug)}"
             alt="${p.brand}: ${p.title}"
             loading="lazy"
             decoding="async" />
        <div class="phone__label"><span class="dot"></span>${p.brand}</div>
      </div>
    </button>
  `).join("");

  // -------- Modal: full screenshot viewer ---------------------------------
  const modal = document.createElement("div");
  modal.className = "previewer";
  modal.setAttribute("aria-hidden", "true");
  modal.innerHTML = `
    <div class="previewer__backdrop" data-close></div>
    <div class="previewer__dialog" role="dialog" aria-modal="true">
      <div class="previewer__head">
        <span class="previewer__brand"></span>
        <button class="previewer__close" type="button" aria-label="Close" data-close>&times;</button>
      </div>
      <div class="previewer__stage">
        <div class="previewer__frame">
          <div class="previewer__scroll">
            <img class="previewer__img" alt="" />
          </div>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const imgEl    = modal.querySelector(".previewer__img");
  const brandEl  = modal.querySelector(".previewer__brand");
  const scrollEl = modal.querySelector(".previewer__scroll");

  function openPreview(slug, brand) {
    imgEl.src = fullUrl(slug);
    imgEl.alt = brand;
    brandEl.textContent = brand;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    requestAnimationFrame(() => {
      scrollEl.scrollTop = 0;
    });
  }

  function closePreview() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  modal.addEventListener("click", (e) => {
    if (e.target.matches("[data-close]")) closePreview();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) closePreview();
  });

  document.querySelectorAll(".phone").forEach(phone => {
    phone.addEventListener("click", () => {
      openPreview(phone.dataset.slug, phone.dataset.brand);
    });
  });
})();

// -------- Smooth scroll ----------------------------------------------------
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener("click", e => {
    const id = a.getAttribute("href");
    if (id.length < 2) return;
    const target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

// -------- Wins rail: dots on mobile ----------------------------------------
(function winsRail() {
  const rail = document.getElementById("winsRail");
  const dotsEl = document.getElementById("winsDots");
  if (!rail || !dotsEl) return;
  const cards = Array.from(rail.querySelectorAll(".win"));
  if (!cards.length) return;
  dotsEl.innerHTML = cards.map((_, i) =>
    `<button class="dot" type="button" data-i="${i}" aria-label="Scroll to card ${i + 1}"></button>`
  ).join("");
  const dots = Array.from(dotsEl.querySelectorAll(".dot"));
  const step = () => cards.length < 2 ? rail.clientWidth :
    cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
  const update = () => {
    const s = step();
    const i = s ? Math.max(0, Math.min(cards.length - 1, Math.round(rail.scrollLeft / s))) : 0;
    dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
  };
  dots.forEach(d => d.addEventListener("click", () =>
    rail.scrollTo({ left: parseInt(d.dataset.i, 10) * step(), behavior: "smooth" })));
  rail.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
})();

// -------- Hero: auto-calculate go-live date (today + 7 days, push weekends to Monday)
(function heroDate() {
  const el = document.getElementById("heroDate");
  if (!el) return;
  const d = new Date();
  d.setDate(d.getDate() + 7);
  const day = d.getDay(); // 0=Sun, 6=Sat
  if (day === 6) d.setDate(d.getDate() + 2);
  if (day === 0) d.setDate(d.getDate() + 1);
  el.textContent = d.toLocaleDateString("en-US", { month: "long", day: "numeric" });
})();

// -------- Nav: add glass blur only after scroll ---------------------------
(function navScrollGlass() {
  const nav = document.querySelector(".nav");
  if (!nav) return;
  const toggle = () => {
    if (window.scrollY > 8) nav.classList.add("nav--scrolled");
    else nav.classList.remove("nav--scrolled");
  };
  toggle();
  window.addEventListener("scroll", toggle, { passive: true });
})();

// -------- Email copy-to-clipboard ----------------------------------------
(function emailCopy() {
  const btn = document.getElementById("emailCopyBtn");
  if (!btn) return;
  const email = btn.dataset.email || "";
  const defaultEl = btn.querySelector(".btn--copy__default");
  const defaultHTML = defaultEl ? defaultEl.innerHTML : "";
  let timer;

  const markCopied = () => {
    btn.classList.add("is-copied");
    if (defaultEl) defaultEl.textContent = "Copied ✓";
    clearTimeout(timer);
    timer = setTimeout(() => {
      btn.classList.remove("is-copied");
      if (defaultEl) defaultEl.innerHTML = defaultHTML;
    }, 2000);
  };

  const fallbackCopy = () => {
    const ta = document.createElement("textarea");
    ta.value = email;
    ta.setAttribute("readonly", "");
    ta.style.position = "absolute";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
      markCopied();
    } catch (e) {
      window.prompt("Copy this email:", email);
    }
    document.body.removeChild(ta);
  };

  btn.addEventListener("click", () => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(email).then(markCopied).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  });
})();
